<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Heading, Text } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

interface Props {
  firstName: string;
}

defineProps<Props>();

const emit = defineEmits<{
  continue: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center text-center">
    <KUIUnifiedBlinky
      size="lg"
      gaze="centered"
      class="mb-4"
    />

    <Heading
      size="3xl"
      as="h1"
      class="mb-3"
    >
      {{ firstName ? t('general.auth.youreIn', { firstName }) : t('general.auth.youreInNoName') }}
    </Heading>

    <Text size="lg" class="mb-10">
      {{ t('general.auth.letsFind') }}
    </Text>

    <Button
      variant="secondary"
      size="lg"
      data-testid="auth-submit-button"
      type="button"
      class="w-full"
      @click="emit('continue')"
    >
      {{ t('general.auth.startExploring') }}
    </Button>
  </div>
</template>
